<mat-card>
  <mat-card-content>
    <div class="header-section">
      <h1>{{ measureName }} - Patient Details</h1>
    </div>
    
    <div class="content">
      @if (hasNoPatientData) {
        <div class="no-patient-data-message">
          <mat-icon class="no-patient-data-icon">info_outline</mat-icon>
          <p>
            This is either a parent population or a virtual(calculated)
            population and does not have patient data to display.
          </p>
        </div>
      } @else {
        <ag-grid-angular
          style="width: 100%; height: 600px"
          [theme]="theme"
          [rowData]="rowData"
          [columnDefs]="colDefs"
          [suppressCellFocus]="true"
          [defaultColDef]="defaultColDef"
          [gridOptions]="gridOptions"
          [components]="frameWorkComponents"
          [paginationAutoPageSize]="true"
          [cacheBlockSize]="cacheBlockSize"
          [cacheOverflowSize]="cacheOverflowSize"
          [maxConcurrentDatasourceRequests]="maxConcurrentDatasourceRequests"
          [infiniteInitialRowCount]="infiniteInitialRowCount"
          [maxBlocksInCache]="maxBlocksInCache"
          (cellClicked)="onCellClicked($event)"
        />
      }
    </div>

  </mat-card-content>
</mat-card>
